/**
 * AI 跟单：投资金额输入框下方错误文案（列表卡 / 详情 / 加仓页共用）
 * 避免「余额不足」场景仍出现 between 98.12 and 98.12 等歧义提示。
 */

import { formatAicopyAvailableBalanceDisplay } from "./aicopyCurrencies";

/** Amount range / 区间错误文案：整数不写 .00；非整数仍保留两位小数 */
export function formatAicopyAmountRangeLabel(n, formatNumber) {
  if (!Number.isFinite(n)) return "";
  const rounded = Math.round(n);
  if (Math.abs(n - rounded) < 1e-9) {
    const s = String(rounded);
    return formatNumber ? formatNumber(s) : s;
  }
  const s = n.toFixed(2);
  return formatNumber ? formatNumber(s) : s;
}

export function getAicopyInvestmentAmountErrorMsg({
  amountNum,
  currentAvailableNum,
  currentAvailableBalanceStr,
  minIn,
  maxIn,
  formatNumber,
  currency,
  t,
}) {
  const eps = 1e-8;
  if (!Number.isFinite(amountNum) || amountNum <= 0) return null;
  if (!Number.isFinite(minIn) || !Number.isFinite(maxIn)) return null;

  if (amountNum > currentAvailableNum + eps) {
    return t("convert.errorInsufficient");
  }

  if (Number.isFinite(currentAvailableNum) && currentAvailableNum + eps < minIn) {
    return t("aicopy.balanceBelowMinimumInvest", {
      min: formatAicopyAmountRangeLabel(minIn, formatNumber),
      available: formatAicopyAvailableBalanceDisplay(
        currentAvailableBalanceStr ?? String(currentAvailableNum),
        formatNumber
      ),
      currency,
    });
  }

  const belowMin = amountNum < minIn - eps;
  const aboveMax = amountNum > maxIn + eps;
  if (!belowMin && !aboveMax) return null;

  if (Math.abs(minIn - maxIn) <= 1e-6) {
    if (aboveMax) return t("convert.errorInsufficient");
    return t("aicopy.investmentAmountMustBe", {
      amount: formatAicopyAmountRangeLabel(minIn, formatNumber),
      currency,
    });
  }

  return t("aicopy.investmentAmountOutOfRange", {
    min: formatAicopyAmountRangeLabel(minIn, formatNumber),
    max: formatAicopyAmountRangeLabel(maxIn, formatNumber),
    currency,
  });
}
